module.exports = __webpack_public_path__ + "static/media/loader.774e0fe0.svg";